import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["value", "className", "loadOptions", "onChange", "onBlurSearch", "onChangeType", "isTypeRadio", "type", "customOption", "typeOptions"];
import React, { Fragment, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, SearchBar, Radio, Text, useTheme } from 'hoi-poi-ui';
import classnames from 'classnames';
import { useWeb5Context } from "../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'SectionToolbarSearch');
function SectionToolbarSearch(_ref) {
  let {
      value,
      className,
      loadOptions,
      onChange,
      onBlurSearch,
      onChangeType,
      isTypeRadio,
      type,
      customOption = null,
      typeOptions
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const classNames = useMemo(() => classnames({
    [classes === null || classes === void 0 ? void 0 : classes.SectionToolbarSearch]: !typeOptions,
    [classes === null || classes === void 0 ? void 0 : classes.withOptions]: typeOptions
  }, className), [className, typeOptions, classes]);
  const customTypeOption = useCallback(item => {
    if (!onChangeType || !isTypeRadio) return;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.typeOptionRow
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.typeOptionRowRadio
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: item.value === (type === null || type === void 0 ? void 0 : type.value),
      overrides: {
        svg: {
          viewBox: '0 0 24 24',
          width: 18,
          height: 18
        }
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.typeOptionRowMainInfo
    }, /*#__PURE__*/React.createElement(Text, {
      className: classes.typeOptionRowTitle,
      type: "subtitle",
      isTruncated: true
    }, item.label), item.label2 && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Text, {
      className: classes.typeOptionRowInfo,
      type: "caption",
      color: theme.colors.textLight.secondary
    }, item.label2), ",")));
  }, [classes.typeOptionRow, classes.typeOptionRowInfo, classes.typeOptionRowMainInfo, classes.typeOptionRowRadio, classes.typeOptionRowTitle, isTypeRadio, onChangeType, type === null || type === void 0 ? void 0 : type.value, theme]);
  const overrides = useMemo(() => {
    if (!onChangeType) return;
    return {
      TypeSelector: {
        isRequired: true,
        hideSelectedOptions: false,
        hideDropdownIndicator: false,
        cacheOptions: false,
        dropdownWidth: '320px',
        overrides: {
          inputComponents: {
            style: {
              maxWidth: '150px'
            }
          }
        }
      }
    };
  }, [onChangeType]);
  return /*#__PURE__*/React.createElement(SearchBar, _extends({
    className: classNames,
    placeholder: t('cfm_placeholder_search'),
    size: "small",
    highlightMatch: true,
    forceBlurOnEnter: true,
    focusDefaultOption: false,
    hideDropdownIndicator: false,
    value: value,
    loadOptions: loadOptions,
    onChange: onChange,
    onBlurSearch: onBlurSearch,
    type: type,
    onChangeType: onChangeType,
    customTypeOption: customTypeOption,
    customOption: customOption,
    overrides: overrides,
    typeOptions: typeOptions,
    notSelectingDefaultOption: true,
    keepInputFocused: true
  }, props));
}
process.env.NODE_ENV !== "production" ? SectionToolbarSearch.propTypes = {
  value: PropTypes.object.isRequired,
  loadOptions: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlurSearch: PropTypes.func.isRequired
} : void 0;
export default /*#__PURE__*/React.memo(SectionToolbarSearch);